module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/delete-c4bd25176828a32c731c0f556f85715c.png";